import { Check, Clock3, Copy, ExternalLink, MapPin, X } from "lucide-react";
import type { Job } from "../types";

export function JobCard({ job, onStatus }: { job: Job; onStatus: (id: string, status: Job["status"]) => void }) {
  const copyAnswers = async () => {
    await navigator.clipboard?.writeText(`Experiencia relevante: ${job.matchingSkills.join(", ")}.`);
  };

  return (
    <article className="job-card">
      <div className="score-ring" style={{ "--score": `${job.score * 3.6}deg` } as React.CSSProperties}>
        <span>{job.score}%</span>
      </div>
      <div className="job-main">
        <div className="job-heading">
          <div>
            <div className="eyebrow"><span>{job.source}</span> · {job.discoveredAt}</div>
            <h3>{job.title}</h3>
            <p className="company">{job.company}</p>
          </div>
          <span className={`status-pill ${job.status.toLowerCase()}`}>
            {job.status === "APPLICATION_OPENED" ? <Clock3 size={14} /> : <Check size={14} />}
            {job.status.replaceAll("_", " ")}
          </span>
        </div>
        <div className="job-meta">
          <span><MapPin size={15} /> {job.location}</span>
          <span>{job.modality}</span>
          <span>{job.salary}</span>
        </div>
        <div className="skills-grid">
          <div><small>Coincidencias</small><div className="chips">{job.matchingSkills.map((skill) => <span className="chip good" key={skill}>{skill}</span>)}</div></div>
          <div><small>Por reforzar</small><div className="chips">{job.missingSkills.map((skill) => <span className="chip muted" key={skill}>{skill}</span>)}</div></div>
        </div>
        <div className="resume-line"><span>CV recomendado</span><strong>{job.recommendedCv}</strong></div>
        <div className="card-actions">
          <a className="button primary" href={job.url} target="_blank" rel="noreferrer" onClick={() => onStatus(job.id, "APPLICATION_OPENED")}><ExternalLink size={16} /> Abrir oferta</a>
          <button className="button" onClick={() => onStatus(job.id, "APPLIED_CONFIRMED")}><Check size={16} /> Marcar aplicada</button>
          <button className="button icon" onClick={copyAnswers} title="Copiar respuesta sugerida"><Copy size={16} /></button>
          <button className="button icon danger" title="Descartar"><X size={16} /></button>
        </div>
      </div>
    </article>
  );
}
